import React from 'react'
import { Item } from './Item'
import { Box, Center } from '@chakra-ui/react'
import { FixedSizeList as List } from 'react-window'
import { isEmpty } from 'lodash'

export const VersionsList = React.forwardRef(({ data, activeIndex, onItemClick }, ref) => {
  const Row = ({ index, key, style }) => (
    <div key={key} style={style} className="post">
      <Item
        data={data}
        index={index}
        activeIndex={activeIndex}
        onClick={onItemClick}
      />
    </div>
  )

  if (isEmpty(data)) {
    return (
      <Center backgroundColor="whiteAlpha.100" height="300px">
        Нет версий
      </Center>
    )
  }

  return (
    <Box backgroundColor="whiteAlpha.100" ref={ref}>
      <List
        width="100%"
        height={300}
        itemCount={data?.length}
        itemSize={56}
      >
        {Row}
      </List>
    </Box>
  )
})
